module.exports = __webpack_public_path__ + "img/37.d7d764cd.jpg";